import { SxProps } from '@mui/material';

export const DefaultSx: SxProps = {
  backgroundColor: 'transparent',
  '& .MuiFormControl-root': {
    backgroundColor: 'transparent',
  },
};
